import { post } from '@/utilities/onwardClient';
import { SCHEDULE_ORDER_CALL } from '@/constants/apiRoutes';

export const scheduleCall = async ({ order }) => {
    return post(SCHEDULE_ORDER_CALL, {
        order_id: order.order_id,
    });
};
